import type { BannerState } from "../types";

interface Props {
  banner: BannerState;
}

const ICONS: Record<BannerState["level"], string> = {
  green: "●",
  red: "●",
  yellow: "●",
  grey: "○",
};

export function Banner({ banner }: Props) {
  const isAlert = banner.level === "red";
  return (
    <div
      className={`banner banner-${banner.level}`}
      role={isAlert ? "alert" : "status"}
      aria-live={isAlert ? "assertive" : "polite"}
    >
      <span className="banner-dot" aria-hidden="true">
        {ICONS[banner.level]}
      </span>
      <div className="banner-text">
        <div className="banner-headline">{banner.headline}</div>
        {banner.detail ? (
          <div className="banner-detail">{banner.detail}</div>
        ) : null}
      </div>
    </div>
  );
}
